<template>
  <div class="content">
    <span>Ông/bà</span>
    <span class="highlight font-weight__bold"> {{ fromActorFullName }} </span>
    <span>đã </span>
    <span class="highlight-action"> {{ action }} </span>
    <span> đơn </span>
    <span class="event">"{{ taskTitle }}"</span>
  </div>
</template>

<script>
import constants from "../../constants";

export default {
  name: "notification-item-cv",
  props: ["vbNotificationView"],
  data() {
    return {
      fromActorFullName: null,
      action: null,
      taskTitle: null,
      dataJson: null,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.dataJson = JSON.parse(this.vbNotificationView.dataJson);
      let action;
      console.log('this.vbNotificationView.messageType',this.vbNotificationView.messageType)
      switch (this.vbNotificationView.messageType) {
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.LETTER.YEU_CAU:
          action = "Gửi";
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.LETTER.PHE_DUYET:
          action = "Phê duyệt";
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.LETTER.TU_CHOI:
          action = "Từ chối";
          break;
        default:
          action = "";
          break;
      }
      this.fromActorFullName = this.vbNotificationView.fromUserName || "-";
      this.action = action;
      if(this.dataJson.form.type === 1) {
        this.taskTitle = `xin nghỉ phép`;
      }
      if(this.dataJson.form.type === 2) {
        this.taskTitle = `xin vắng mặt`;
      }
      if(this.dataJson.form.type === 3) {
        this.taskTitle = `giải trình`;
      }
      if(this.dataJson.form.type === 4) {
        this.taskTitle = `tăng ca`;
      }
      if(this.dataJson.form.type === 5) {
        this.taskTitle = `công tác`;
      }

    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/header/notification-item-letter.vue